export const siteConfig = {
  title: "Sacred Delights",
  description: "",

  pagesContent: {
    "/about": {
      headerTitle: "About us",
      headerDescription: "",
      secondaryText:
        "At Sacred Delights, we believe that dessert is more than just something sweet — it’s a moment, a feeling, a memory in the making. Our story began not in a perfect kitchen, but in a small town far away, with a simple desire: to create something special for someone we love. What started as a single imperfect cake became a journey of passion, growth, and dedication to the art of fine desserts. Today, Sacred Delights is a reflection of that journey. Every creation is thoughtfully crafted, not mass-produced. We focus on the details that truly matter — from the balance of flavors to the elegance of presentation. We use carefully selected ingredients, including premium Belgian chocolate, to ensure each dessert feels as exceptional as the moment it’s made for. But what truly defines us is intention. Our desserts are made for more than celebrations. They are made for quiet dinners, meaningful conversations, and the simple desire to turn an ordinary day into something beautiful. Because luxury doesn’t mean something made just for you. Welcome to Sacred Delights — where every dessert tells a story.",
      imageUrl:
        "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/6B05B593-278E-4127-A7F8-FE2B8BDDADE7.webp",
    },
    "/story": {
      headerTitle: "Story",
      headerDescription:
        "March 21, 2019. The day before my daughter’s birthday. She was turning 10. Like any mom, I wanted to do something special. At that time, we were living in a small town in the far north of Russia — you know, where it’s freezing almost all year, the northern lights glow in the sky, and sometimes even bears wander out of the forest into the streets. Not exactly a place with endless options to impress a child! As someone who loves creating a little magic in the kitchen, I decided to bake a cake. But the magic didn’t happen... This happened instead...",
      secondaryText:
        "That was a turning point. The kind of moment when you open the fridge and tears come to your eyes — not from pride or joy, but from the feeling that you could have done better... and didn’t. home. Thankfully, I had friends who were more than happy to taste everything! Then came the first orders. And then... I got tired. Maybe even a little burned out. Then life changed — I moved to the United States. And as many know, life in a new country doesn’t always fall into place quickly or smoothly. But love for beauty and a bit of magic doesn’t just disappear. Over the years in the U.S., I kept baking — bringing my cakes to birthdays, celebrations, and gatherings for friends, colleagues, reactions... The way people felt when they tasted my desserts... hat became the final note. And I thought — why not try?",
      imageUrl:
        "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/images//story.webp",
    },
    "/contact": {
      headerTitle: "Contact us",
      headerDescription: "",
      secondaryText: "",
      imageUrl:
        "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/images/pickup-location.webp",
    },
    "/request": {
      headerTitle: "Request order",
      headerDescription:
        "Choose a dessert from our menu, or select “Signature cakes” to share your own idea. Add any details, flavors, or special requests, and we’ll get in touch with you to discuss the details and create something special just for you.",
      secondaryText: "",
      imageUrl:
        "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/B579DE0B-A47A-4F5E-8CFC-18188C74C0E8.webp",
    },
    "/portfolio": {
      headerTitle: "Portfolio",
      headerDescription: "A glimpse into the world of Sacred Delights",
      secondaryText: "",
      imageUrl:
        "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/6B05B593-278E-4127-A7F8-FE2B8BDDADE7.webp",
    },
    "/menus/SignatureCakes": {
      headerTitle: "Signature Cakes",
      headerDescription:
        "A collection of timeless favorites and elegant creations, featuring a variety of flavors, textures, and styles - each thoughtfully crafted to delight every taste.",
      secondaryText: "",
      imageUrl:
        "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/54FCEEB5-472A-43B6-94FA-C9E19FA6A23B.webp",
    },
    "/menus/HoneyCake": {
      headerTitle: "Honey Cake",
      headerDescription:
        "A collection of delicate honey cakes, crafted with thin, tender layers and luxurious fillings. From classic Medovik to pistachio, raspberry, caramel, and nuts - each cake is made to be beautifully balanced, rich and unforgettable.",
      secondaryText: "",
      imageUrl:
        "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/54FCEEB5-472A-43B6-94FA-C9E19FA6A23B.webp",
    },
    "/menus/MeringueRoll": {
      headerTitle: "Meringue Roll",
      headerDescription:
        "Delicate, airy meringue paired with silky cream and a variety of thoughtfully crafted fillings and flavors. From fruity and refreshing to rich and nutty, each combination has its own character - made to suit every taste.",
      secondaryText: "",
      imageUrl:
        "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/54FCEEB5-472A-43B6-94FA-C9E19FA6A23B.webp",
    },
    "/menus/TresLeches": {
      headerTitle: "Tres Leches",
      headerDescription:
        "A delicate sponge soaked in three milks, paired with silky creams and vibrant flavors - irresistibly moist, light and beautifully indulgent.",
      secondaryText: "",
      imageUrl:
        "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/54FCEEB5-472A-43B6-94FA-C9E19FA6A23B.webp",
    },
  },
};
